export default __webpack_public_path__ + "static/media/india_flag.c8ec783a.png";